import Util from '../script/util';
import HTTP from '../script/service';
import store from './store';
import { message, Modal } from 'antd';

const ARTC = (window,
function () {
  const that = {
    token: null,
    client: null,
    joined: false,
    published: false,
    localStream: null,
    params: {},
    device_list: [],
    mic_list: [],
    liveConfig: {},
    audioVolume: 100, //伴奏音量
    playVolume: 100,
    disAudio: false, //是否静音
  };
  //初始化
  that.openConn = function (room) {
    that.room = room;
    that.liveConfig = room.liveConfig || {};
    if (!that.client) {
      initClient(function () {
        bindEvent();
        setSysConfig();
        joinChannel();
      });
    } else {
      setSysConfig();
      joinChannel();
    }
    return that;
  };
  //实例化客户端
  function initClient(callback) {
    const { rootConfig } = store.getState();
    that.default_mic = null;
    that.default_div = null;
    that.audio_state = false; //伴奏状态
    that.dev_state = true; //扬声器状态
    that.mic_state = true; //麦克风状态
    that.disAudio = false; //是否静音
    that.wifiDown = document.getElementById('wifi-down');
    that.wifiUp = document.getElementById('wifi-up');
    Util.$interface(
      '_init_agora_client',
      { agoraAppID: rootConfig.agoraAppID },
      '_init_agora_client',
      function (result) {
        if (result.state == 1) {
          that.client = true;
          getDevices().then(callback);
        }
      }
    );
  }
  //获取设备
  function getDevices(upMic) {
    return new Promise((resolve, reject) => {
      Util.$interface(
        '_get_agora_devices',
        {},
        '_get_agora_devices',
        function (result) {
          that.mic_list = Array.prototype.slice.call(result.mic_devices);
          that.device_list = Array.prototype.slice.call(result.speak_devices);
          setDefaultDevices(upMic);
          resolve();
        }
      );
    });
  }
  //设置默认设备
  function setDefaultDevices(upMic) {
    that.audioVolume = 100;
    that.playVolume = 100;
    //伴奏音量
    let audioVolume = Util.readCookie('audioVolume');
    if (audioVolume && !isNaN(audioVolume)) {
      that.audioVolume = parseInt(audioVolume);
    }
    //扬声器音量
    let playVolume = Util.readCookie('playVolume');
    if (playVolume && !isNaN(playVolume)) {
      that.playVolume = parseInt(playVolume);
    }

    if (that.device_list.length < 1) {
      that.device_list = [
        {
          deviceId: 'default',
          groupId: '',
          kind: 'audioinput',
          label: '默认 - 线路',
        },
      ];
    }
    if (upMic && that.mic_list.length < 1) {
      message.error('麦克风设备检测异常：请确麦克风/声卡设备连接正常后重试~');
      return;
    }
    //设置默认设备
    let def_d = Util.readCookie('default_div');
    if (def_d) {
      that.default_div = JSON.parse(def_d);
    } else {
      that.default_div = that.device_list[0];
    }
    let def_m = Util.readCookie('default_mic');
    if (def_m) {
      that.default_mic = JSON.parse(def_m);
    } else {
      that.default_mic = that.mic_list[0];
    }
  }
  //基础设置
  function setSysConfig() {
    //音质设置 统一使用高音质
    Util.$interface(
      '_setAudioProfile',
      { profile: 5, scenario: 3 },
      '_setAudioProfile',
      function () {}
    ); //高清
    // Util.$interface('_setAudioProfile', { profile: 0, scenario: 0 }, '_setAudioProfile', function () { }); //默认
  }
  //加入频道
  function joinChannel() {
    //先给自己设定 观众 角色
    Util.$interface(
      '_set_agora_role',
      { role: 2 },
      '_set_agora_role',
      function () {
        Util.$interface('_mute_agroa_play_volume', { volume: that.playVolume });
      }
    );
    //每次加入默认解开
    that.room.events['CHANGE_DEV_STATE'] &&
      that.room.events['CHANGE_DEV_STATE'](false);
    HTTP._get_agora_token({
      uid: that.room.uid || 0,
      channelName: that.room.roomid,
    }).then(async (res) => {
      if (res?.code === 200) {
        const data = res.data;
        that.token = data.token;
        Util.$interface(
          '_join_agora_client',
          {
            token: that.token,
            clientid: that.room.roomid,
            uid: that.room.uid,
          },
          '_join_agora_client',
          function (result) {
            if (result.state == 1) {
              that.params.uid = result.uid;
              that.joined = true;
              if (!that.room.conn) {
                that.destroyRoom(3);
              } else {
                that.delToMic(2);
              }
            }
          }
        );
      } else {
        message.warning(res.message);
      }
    });
  }
  //音频流事件监听
  function bindEvent() {
    //监听说话者音量提示
    window.Config['_on_agora_users_volume'] = function (result) {
      let speakMembers = {};
      result.data &&
        result.data.forEach((item) => {
          if (item.uid == 0) {
            item.uid = that.room.uid;
          }
          if (item.level > 100) speakMembers[item.uid.toString()] = item.level;
        });
      if (that.room.hasLive()) {
        that.room.showSpeakUsers(speakMembers);
      }
    };
    //监听上下行网络质量报告
    window.Config['_on_agora_network_quality'] = function (result) {
      if (result.uid == that.room.uid || result.uid == 0) {
        if (that.wifiDown)
          that.wifiDown.className = 'w-down d-' + result.rxQuality;
        if (that.wifiUp) that.wifiUp.className = 'w-up d-' + result.txQuality;
      }
    };
    //与服务器异常断开回调
    window.Config['_on_agora_client_error'] = function (result) {
      message.error('服务器的连接因为网络原因断开了，系统会自动尝试重连。');
    };
    //与服务器重新建立连接
    window.Config['_on_agora_reconnect'] = function (result) {
      message.warning('系统正在重新建立连接。');
    };
    //token过期
    window.Config['_on_agora_request_token'] = function (result) {
      Modal.confirm({
        title: '系统提示',
        icon: null,
        closable: true,
        content: '你的token权限失效，请退出房间重现进入。',
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk() {
          window.location.reload();
        },
        onCancel() {
          window.location.reload();
        },
      });
    };
    //伴奏播放结束
    window.Config['_on_remote_audio_mixing_end'] = function (result) {
      clearTimeout(that.timePlayEvel);
      if (that.localStream) {
        that.playMusic.play = false;
        that.room.events['CHANGE_AUDIO_STATE'] &&
          that.room.events['CHANGE_AUDIO_STATE'](1, that.audioVolume);
        that.room.events['CHANGE_AUDIO_NEXT'] &&
          that.room.events['CHANGE_AUDIO_NEXT']();
      }
    };
  }
  //创建本地流
  function createLocalStream(callback) {
    Util.$interface(
      '_set_agora_role',
      { role: 1 },
      '_set_agora_role',
      function (result) {
        if (result.state == 1) {
          that.localStream = that.room.uid;
          callback && callback();
          //打开麦克风
          Util.$interface('_mute_agora_local_stream', { volume: 100 });
          //去掉本地静音
          Util.$interface('_mute_agora_me_stream', { mute: 0 });
        }
      }
    );
  }
  //更新直播队列
  function getLiveConfig(callback) {
    //直播上报
    HTTP._mixed_channel_create({
      uid: that.room.uid,
      roomid: that.room.roomid,
      roomcid: that.room.roomid,
      creator: that.room.account,
    });
    const { rootConfig } = store.getState();
    //如果直播已经存在
    if (that.room.hasLive()) {
      that.liveConfig = {
        channelName: that.room.roomid, //房间名称
        channelId: null, //通话渠道 由网易返回
        creator: that.room.account, //直播创建者
        cid: null, //通话cid标识 由接口返回
        pushUrl: null, //推流地址
        rtmpPullUrl: null, //拉流地址
        web_version: rootConfig.version, //网页独有版本参数
        pc_version: that.room.base.clientInfo.version, //pc独有版本参数
        master_type: that.room.base.client, //主播当前终端类型
        config: [...that.room.liveConfig.config], //麦位属性配置
      };
    } else {
      that.liveConfig = {
        channelName: that.room.roomid, //房间名称
        channelId: null, //通话渠道 由网易返回
        creator: that.room.account, //直播创建者
        cid: null, //通话cid标识 由接口返回
        pushUrl: null, //推流地址
        rtmpPullUrl: null, //拉流地址
        web_version: rootConfig.version, //网页独有版本参数
        pc_version: that.room.base.clientInfo.version, //pc独有版本参数
        master_type: that.room.base.client, //主播当前终端类型
        config: [], //麦位属性配置
      };
      for (let i = 0; i < 9; i++) {
        that.liveConfig.config.push({
          index: i, //麦位
          type: i == 0 ? 0 : 1, //类型  0 主播位置 1 互动位  2 老板位
          enabled: true, // 是否启用用位置
          microphone: true, // 是否启用麦克风
          disAudio: false, //是否静音
        });
      }
    }
    //2、发送麦位配置
    that.room.modifyConfig(that.liveConfig, false, function () {
      //3、发送1-1指令
      that.room.sendCustomMsg({
        action: '1-1',
        creator: that.room.account,
      });
      callback && callback();
    });
  }
  //开始播放新的伴奏
  function startAudioMixing(callback) {
    clearTimeout(that.playTmer);
    //先设置一次播放音量
    Util.$interface('_change_agroa_audio_mixing_volume', {
      volume: that.audioVolume,
    });
    let filePath = window.encodeURIComponent(that.playMusic.url);
    Util.$interface(
      '_start_agroa_audio_mixing',
      { filePath: filePath },
      '_start_agroa_audio_mixing',
      function (result) {
        if (result.state == 1) {
          that.playMusic.playing = true;
          that.playMusic.play = true;
          callback && callback(2);
          //获取一次时长
          Util.$interface(
            '_get_agroa_audio_mixing_duration',
            {},
            '_get_agroa_audio_mixing_duration',
            function (result) {
              if (result.state == 1) {
                let timeParam = Util.formatDuring(result.duration);
                let dom = document.getElementById('music-all-time');
                if (dom) {
                  dom.innerHTML = timeParam.minutes + ':' + timeParam.seconds;
                }
                //获取播放时长
                that.playTmer = setTimeout(() => {
                  that.playMusic.playing = true;
                  that.playMusic.play = true;
                  timeoutGetPlayTime();
                }, 1000);
              }
            }
          );
        } else {
          message.error(
            '音乐播放异常，该首歌曲可能已损坏，请在系统中删除后重新上传。'
          );
          that.playMusic = null;
          callback && callback(2, result.error);
        }
      }
    );
  }
  //定时获取 播放时间
  function timeoutGetPlayTime() {
    clearTimeout(that.timePlayEvel);
    if (!that.localStream) return;
    if (!that.playMusic) return;
    if (!that.playMusic.play) return;
    Util.$interface(
      '_get_agroa_audio_mixing_position',
      {},
      '_get_agroa_audio_mixing_position',
      function (result) {
        if (result.state == 1) {
          let timeParam = Util.formatDuring(result.position);
          let dom = document.getElementById('music-play-time');
          if (dom) {
            dom.innerHTML = timeParam.minutes + ':' + timeParam.seconds;
          }
        }
        that.timePlayEvel = setTimeout(timeoutGetPlayTime, 1000);
      }
    );
  }
  function joinSuccess(callback) {
    that.published = true;
    that.room.queuePoll(`queue_${that.room.uid}`);
    //如果当前在相亲模式-并且游戏进行中, 用户需要上报
    if (
      that.room.roomInfo &&
      that.room.roomInfo.custom &&
      that.room.roomInfo.custom.rmode == 1 &&
      that.room.datingData &&
      that.room.datingData.sdata
    ) {
      HTTP._addDataingUser({
        roomid: that.room.roomid,
        uids: that.room.uid,
      });
    }
    //派单房, 用户需要上报 todo 2.21.3 更改为所有房间都上报
    // if (that.room.roomInfo && that.room.roomInfo.custom && that.room.roomInfo.custom.rmode == 6 && that.room.sendOrders && that.room.sendOrders.msgId) {
    if (that.room.base.microType === 0) {
      if (that.room.roomInfo && that.room.roomInfo.custom) {
        let meque = that.room.queueObject[that.room.account];
        let msgId = null;
        if (
          that.room.roomInfo.custom.rmode == 6 &&
          that.room.sendOrders &&
          that.room.sendOrders.msgId
        ) {
          msgId = that.room.sendOrders.msgId;
        }
        if (meque) {
          HTTP._oneorder_upMicrophone({
            uid: that.room.uid,
            roomId: that.room.roomid,
            index: meque.index,
            msgId,
          });
        }
      }
    }
    callback && callback();
  }
  //设置伴奏音量
  that.setAudioVolume = function (volume, mute) {
    if (!that.localStream) return false;
    if (mute) {
      Util.$interface('_change_agroa_audio_mixing_volume', { volume: 0 });
      return true;
    }
    if (volume < 0) volume = 0;
    if (volume > 100) volume = 100;
    Util.$interface('_change_agroa_audio_mixing_volume', { volume: volume });
    Util.setCookie('audioVolume', volume);
    that.audioVolume = volume;
    return true;
  };
  //设置扬声器音量
  that.setPlayVolume = function (volume) {
    that.dev_state = true;
    Util.setCookie('playVolume', volume);
    that.playVolume = volume;
    Util.$interface('_mute_agroa_play_volume', { volume: that.playVolume });
  };
  //开启本地扬声器设备
  that.changeVoiceState = function (open, dev) {
    if (!that.client) return false;
    that.dev_state = open;
    //改变扬声器图标
    if (that.dev_state) {
      that.room.events['CHANGE_DEV_STATE'] &&
        that.room.events['CHANGE_DEV_STATE'](false);
    } else {
      that.room.events['CHANGE_DEV_STATE'] &&
        that.room.events['CHANGE_DEV_STATE'](true);
    }
    //存储 cookie
    if (dev) {
      let oldId = that.default_div ? that.default_div.deviceId : null;
      that.default_div = dev;
      Util.setCookie('default_div', JSON.stringify(that.default_div));
      if (that.localStream && oldId != that.default_div.deviceId) {
        Util.$interface(
          '_select_agroa_speaker',
          { deviceId: that.default_div.deviceId },
          '_select_agroa_speaker',
          function (result) {
            if (result.state == 1) {
              that.room.events['CHANGE_DEV_SELECT'] &&
                that.room.events['CHANGE_DEV_SELECT'](that.playVolume);
            } else {
              message.error('切换扬声器失败，请重试: ', result.error);
            }
          }
        );
      }
    }
    if (that.dev_state) {
      Util.$interface('_mute_agroa_play_volume', { volume: that.playVolume });
      //同步设置一次 伴奏音量
      Util.$interface('_change_agroa_audio_mixing_volume', {
        volume: that.audioVolume,
      });
    } else {
      Util.$interface('_mute_agroa_play_volume', { volume: 0 });
    }
  };
  //开启本地麦克风设备
  that.changeMicState = function (open, mic) {
    if (!that.client) {
      return false;
    }
    that.mic_state = open;
    //改变麦克风图标
    if (that.mic_state) {
      let dom = document.querySelector('.icon-ac-mic');
      if (dom) {
        dom.className = 'icon-ac-mic';
      }
    } else {
      let dom = document.querySelector('.icon-ac-mic');
      if (dom) {
        dom.className = 'icon-ac-mic dis';
      }
    }
    if (mic && that.mic_state) {
      that.default_mic = mic;
      Util.setCookie('default_mic', JSON.stringify(that.default_mic));
      Util.$interface(
        '_select_agroa_mic',
        { deviceId: that.default_mic.deviceId },
        '_select_agroa_mic',
        function (result) {
          if (result.state == 1) {
            that.room.events['CHANGE_MIC_SELECT'] &&
              that.room.events['CHANGE_MIC_SELECT']();
          } else {
            message.error('切换麦克风失败，请重试: ', result.error);
          }
        }
      );
    } else {
      if (that.mic_state) {
        Util.$interface(
          '_mute_agora_local_stream',
          { volume: 100 },
          '_mute_agora_local_stream',
          function (result) {
            that.published = true;
          }
        );
      } else {
        Util.$interface(
          '_mute_agora_local_stream',
          { volume: 0 },
          '_mute_agora_local_stream',
          function (result) {
            that.published = false;
          }
        );
      }
    }
  };
  //开始伴奏
  that.changeAudioState = function (open, playMusic, callback) {
    if (!that.localStream) return;
    if (that.playMusic && that.playMusic.playing == false) return;
    that.audio_state = open;
    if (that.audio_state) {
      //恢复播放
      if (
        that.playMusic &&
        playMusic.url == that.playMusic.url &&
        that.playMusic.play
      ) {
        Util.$interface(
          '_resume_agroa_audio_mixing',
          {},
          '_resume_agroa_audio_mixing',
          function (result) {
            if (result.state == 1) {
              callback && callback(2);
              //获取播放时长
              timeoutGetPlayTime();
            }
          }
        );
        return;
      }
      //如果正在播放 - 先停止
      if (that.playMusic && that.playMusic.play) {
        clearTimeout(that.timePlayEvel);
        Util.$interface(
          '_stop_agroa_audio_mixing',
          {},
          '_stop_agroa_audio_mixing',
          function (result) {
            that.playMusic = { ...playMusic, play: true, playing: false };
            startAudioMixing(callback);
          }
        );
        return;
      }
      //直接新建播放
      that.playMusic = { ...playMusic, play: true, playing: false };
      startAudioMixing(callback);
    } else {
      clearTimeout(that.timePlayEvel);
      Util.$interface(
        '_pause_agroa_audio_mixing',
        {},
        '_pause_agroa_audio_mixing',
        function (result) {
          if (result.state == 1) {
            callback && callback(1);
          } else {
            message.error('伴奏停止异常：' + result.error);
          }
        }
      );
    }
  };
  //上麦
  that.publishLocalStream = function (queue) {
    if (that.slefStream) return;
    return new Promise((resolve, reject) => {
      that.index = queue.index;
      if (that.mic_list.length == 0) {
        that.room.closeLoading && that.room.closeLoading();
        message.error(
          '未检出到你的电脑上有麦克风设备，请检查正确安装/打开后再试。'
        );
        return;
      }
      that.slefStream = true;
      //1. 创建自己的音频流
      createLocalStream(function () {
        //2. 获取设备
        getDevices(true).then(function () {
          if (that.index == 0) {
            //更新直播队列
            getLiveConfig(function () {
              that.published = true;
              //4. 上报
              joinSuccess(function () {
                resolve();
              });
            });
          } else {
            that.published = true;
            //4. 上报
            joinSuccess(function () {
              resolve();
            });
          }
          // 5. 设置一次本地设备
          //初始化设置一次扬声器
          that.changeVoiceState(true, that.default_div);
          //麦克风状态回调
          that.room.events['CHANGE_MIC_STATE'] &&
            that.room.events['CHANGE_MIC_STATE']('block', that.playVolume);
          //显示伴奏状态
          that.room.events['CHANGE_AUDIO_STATE'] &&
            that.room.events['CHANGE_AUDIO_STATE'](true, that.audioVolume);
          that.gameIng(1);
        });
      });
    });
  };
  //踢TA下麦 - 我自己下麦
  that.delToMic = function (n) {
    //麦克风状态回调
    that.room.events['CHANGE_MIC_STATE'] &&
      that.room.events['CHANGE_MIC_STATE']('none', that.playVolume);
    //关闭伴奏状态
    that.room.events['CHANGE_AUDIO_STATE'] &&
      that.room.events['CHANGE_AUDIO_STATE'](false);
    //关闭存在本地流
    if (that.localStream) {
      Util.$interface(
        '_set_agora_role',
        { role: 2 },
        '_set_agora_role',
        function (result) {
          if (that.playMusic && that.playMusic.play) {
            Util.$interface(
              '_stop_agroa_audio_mixing',
              {},
              '_stop_agroa_audio_mixing',
              function (result) {
                that.published = false;
                that.slefStream = false;
                that.localStream = null;
                that.playMusic = null;
              }
            );
          } else {
            that.published = false;
            that.slefStream = false;
            that.localStream = null;
            that.playMusic = null;
          }
        }
      );
    }
    //删除自己的队列
    if (that.room.hasQueume()) {
      that.room.queuePoll(that.room.account, function () {
        that.gameIng(0);
      });
    }
  };
  //发言
  that.changeRoleToPlayer = function () {
    Util.$interface(
      '_mute_agora_me_stream',
      { mute: 0 },
      '_mute_agora_me_stream',
      function (back) {
        that.published = true;
        that.disAudio = false;
      }
    );
  };
  //静音
  that.changeRoleToAudience = function () {
    Util.$interface(
      '_mute_agora_me_stream',
      { mute: 1 },
      '_mute_agora_me_stream',
      function (back) {
        that.published = false;
        that.disAudio = true;
      }
    );
  };
  //销毁离开房间
  that.destroyRoom = function (n) {
    that.delToMic(3);
    that.room.webrtc = null;
    let dom = document.getElementById('local_video');
    if (that.joined == false) {
      that.localStream = null;
      if (dom) dom.innerHTML = '';
      return;
    }
    Util.$interface(
      '_leave_agora_client',
      {},
      '_leave_agora_client',
      function (result) {
        console.log('destroyRoom：', n);
        that.joined = false;
        that.localStream = null;
        that.playMusic = null;
        //清空一次声网播放器
        if (dom) dom.innerHTML = '';
      }
    );
    //关闭底部菜单操作栏
    that.room.events['CHANGE_MIC_STATE'] &&
      that.room.events['CHANGE_MIC_STATE']('none', that.playVolume);
    //关闭伴奏状态
    that.room.events['CHANGE_AUDIO_STATE'] &&
      that.room.events['CHANGE_AUDIO_STATE'](false);
  };
  //是否在游戏中
  that.gameIng = function (status) {};
  //设置变声
  that.setAudioEffectPreset = function (value) {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  };
  //设置美声音效
  that.setVoiceBeautifierPreset = function (value) {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  };
  //设置本地语音音调。
  that.setLocalVoicePitch = function (value) {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  };
  //设置本地语音音效均衡。
  that.setLocalVoiceEqualization = function (value) {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  };
  return that;
})();
export default ARTC;
